import { Component, Input, OnInit } from '@angular/core';
import { BadgeType } from '@constants/badge/1.0';
import { NgClass } from '@angular/common';

@Component({
  selector: 'txp-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  standalone: true,
  imports: [NgClass],
})

/**
 * Displays a badge to the user. Intended for item specific status.
 */
export class BadgeComponent {
  @Input() type: BadgeType | string;
}
